export { default as ApiUris } from "./apiUris";
export { AccountApi } from "./auth-api";
export { UserAPi } from "./user";
export { CompanyAPi } from "./company-api";
export { modelApi } from "./model-api";
export { makeApi } from "./make-api";
export { yearApi } from "./year-api";
export { dealerCompanyApi } from "./dealer-company-api";
export { fleetListApi } from "./fleet-api";
export { fuelListApi } from "./fuel-api";
export { typeListApi } from "./typeList-api";
export { driveTrainListApi } from "./driveTrain-api";
export { replacementScheduleApi } from "./replacementSchedule";
export { fuelAnalysisListApi } from "./fuelAnalysis-api";
export { stateListApi } from "./state-api";
export { maintainanceListApi } from "./maintainance-api";
export { fundListApi } from "./fund-api";
export { newVehicleApi } from "./newVehicle-api";
export { analysisResultApi } from "./analysis-result";
export { SupportAPi } from "./support";
export { helpDeskListApi } from "./helpDesk-api";
export { CommentsApi } from "./comments-api";
export { UserLogsAPi } from "./userlogs-api";
export { fuelPriceApi } from "./fuelPrice-api";
export { movableColumnApi } from "./movableColumn-api";
export { sortableColumnApi } from "./sortableColumn-api";
export { dashboardApi } from "./dashboard-api";
